import { render } from "./FixtureScorboard.vue?vue&type=template&id=a0b91a84&scoped=true"
import script from "./FixtureScorboard.vue?vue&type=script&lang=js"
export * from "./FixtureScorboard.vue?vue&type=script&lang=js"

import "./FixtureScorboard.vue?vue&type=style&index=0&id=a0b91a84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HS\\Desktop\\fikstur\\my_fiksture\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b91a84"]])

export default __exports__